/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef } from 'react';
import location from '../../../common/images/revamp/icon/location.svg';
import { MathRandom, checkTime, checkHoldTime } from '../../../utils/helper';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { ClockIcon } from '@heroicons/react/24/solid';
import { useHistory } from 'react-router-dom';
import { handleOutletByLocation } from '../../../store/reducers/outlet';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { LoaderIcon, PinPointIcon } from '../../../utils/svg';
import ImageLoader from '../../ImageLoader';

const OutletByLocation = (props) => {
	const history = useHistory();

	const dispatch = useDispatch();

	const { isOpen, onClose, latitude, longitude, outletSelected } = props;
	const scrollRef = useRef(null);

	const pageLocation = useSelector((state) => state.outlet?.pageLocation || 0);
	const limitLocation = useSelector((state) => state.outlet?.limitLocation || 10);
	const totalPagesLocation = useSelector((state) => state.outlet?.totalPagesLocation || 0);
	const isLoadMore = useSelector((state) => state.outlet?.isLoadMore || false);
	const outlet = useSelector((state) => state.outlet?.outletByLocation || []);
  const isLoadingOtherLocation = useSelector((state) => state.outlet?.isLoadingOtherLocation || false);  
  const user = useSelector((state) => state.user);

	const handleAction = (item) => {
		if (item && item?.storeOpen === '1') {
			history.push({
				pathname: `/outlet/${item?.storeSlug}/delivery`,
				state: {
					storeID: item?.storeID,
					storeSlug: item?.storeSlug,
					storeName: item?.storeName,
					storeImage: item?.storeImage,
					rating: item?.rating,
					bannerImage: item?.storeBannerImage,
				},
			});
		}
	};

	useEffect(() => {
		if (isOpen && outletSelected?.brandID) {
			dispatch(handleOutletByLocation({
				item: outletSelected,
				latitude,
				longitude,
				page: 1,
				limit: 10,
				isLoadMore: false,
        		companyId: user?.companyID,
			}));
		}
	}, [isOpen, outletSelected]);

  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el || isLoadingOtherLocation) return;
    const nearBottom = (el.scrollHeight - (el.scrollTop + el.clientHeight)) < 100;
  
    if (nearBottom && pageLocation < totalPagesLocation) {
      const nextPage = pageLocation + 1;
      dispatch(handleOutletByLocation({
        item: outletSelected,
        latitude,
        longitude,
        page: nextPage,
        limit: limitLocation,
        isLoadMore: true,
		companyId: user?.companyID,
      }));
    }
  };

	return (
		<BottomSheet open={isOpen} onDismiss={onClose} snapPoints={({ maxHeight }) => [maxHeight - maxHeight / 10]} header={<p className='m-0 py-2 text-left text-lg text-[var(--dark-gray)] font-semibold'>Daftar outlet</p>}>
			<div className='overflow-y-auto px-4 max-h-[47rem]' ref={scrollRef}  onScroll={() => handleScroll()}>
				{!outlet &&
					new Array(6).fill('').map((item, index) => (
						<div key={index} className='flex justify-between gap-3 py-[14px] border-b border-solid border-b-steam last:border-b-0'>
							<div className='rounded-lg w-6 h-6 bg-[var(--pin-ball)] animate-pulse' />
							<div className='grow space-y-1'>
								<div className='h-[21px] rounded-sm bg-[var(--pin-ball)] animate-pulse' style={{ width: `${MathRandom(120, 240)}px` }} />
								<div className='h-[21px] rounded-sm bg-[var(--pin-ball)] animate-pulse' style={{ width: `${MathRandom(60, 80)}px` }} />
								<div className='h-[21px] rounded-sm bg-[var(--pin-ball)] animate-pulse max-w-[calc(100vw-68px)]' style={{ width: `${MathRandom(200, 300)}px` }}></div>
							</div>
						</div>
					))}
				{outlet &&
					outlet.map((item, index) => {
						const isBusy = item?.endHold && checkHoldTime(item?.endHold);
						const outletStatus = isBusy
							? `Resto sedang sibuk`
							: `Tutup${item?.outletOpenTime
								? ` - Buka pukul ${item?.outletOpenTime} ${checkTime(item?.outletOpenTime)} hari ini`
								: ""}`;

                const distance = parseFloat(item?.distance || 0)?.toFixed('2');

						return (
							<div
								key={index}
								className='flex justify-between gap-3 py-[14px] border-b border-solid border-b-steam last:border-b-0'
								onClick={() => {
                  if (item?.outOfDelivery) return;
									handleAction(item);
								}}
								style={{ cursor: item?.storeOpen === '1' && 'pointer' }}>
								<ImageLoader src={item?.storeImage} alt={item?.storeImage} className='rounded-lg w-6 h-6 object-cover object-center' />
								<div className='grow space-y-1'>
									<div className={`${item?.storeOpen === '0' ? 'flex' : 'hidden'} items-center`}>
										<ClockIcon class='h-4 w-4 text-red-500 mr-1' />
										<div className='text-xs font-normal text-gray-900'>{outletStatus}</div>
									</div>
									<div className={`${item?.outOfDelivery && item?.storeOpen === '1' ? 'flex' : 'hidden'} items-center`}>
										<PinPointIcon className={'stroke-red-500 text-red-500 fill-red-500 mr-1'} />
										<div className='text-xs font-normal text-orange-700'>Diluar Jangkauan Pengiriman</div>
									</div>
									<p className={`${(item?.storeOpen === '0' || item?.outOfDelivery) ? 'text-gray-400' : 'text-[var(--dark-gray)]'} mb-0 font-semibold line-clamp-1 max-w-[calc(100vw-68px)] text-sm !mt-0`}>{item?.storeName}</p>
									<div className='flex items-center gap-1'>
										<img src={location} alt='location' />
										<span className='text-xs'>{distance} km</span>
									</div>
									<p className='mb-0 text-[var(--dark-gray)] line-clamp-1 max-w-[calc(100vw-68px)] text-xs'>{item?.storeAddress}</p>
								</div>
							</div>
						);
					})}

				{isLoadMore && (
					<div className='flex justify-center !mt-1'>
						<LoaderIcon />
					</div>
				)}
			</div>
		</BottomSheet>
	);
};

export default OutletByLocation;
